<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-telegram-bot
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @filtering="onFilter"
        ></filter-telegram-bot>
        <v-container>
          <v-layout class="d-flex justify-end px-3 pr-12">
          <a href="https://t.me/uberembot">{{$t('telegram.bot')}}</a>
          </v-layout>
        </v-container>
        <div v-if="paginatedObject.data && paginatedObject.data.length" class="my-3">
          <v-container>
            <v-layout class="d-flex justify-end px-3 pr-12">
              <table class="tableStockItems">
                <tr>
                  <th>ID</th>
                  <th>{{ $t('telegram.userData') }}</th>
                  <th>{{ $t('telegram.dateData') }}</th>
                  <th>{{ $t('telegram.tmpData') }}</th>
                </tr>
                <tr :key="userItem.id" v-for="userItem in paginatedObject.data">
                  <td>{{userItem.id}}</td>
                  <td>
                    <div><b><small>{{ $t('telegram.botName') }}:</small></b></div>
                    <div>{{userItem.name}}</div>
                    <div><b><small>{{ $t('telegram.filledName') }}:</small></b></div>
                    <div>{{userItem.filledName}}</div>
                    <div><b><small>{{ $t('telegram.filledPhone') }}:</small></b></div>
                    <div>{{userItem.filledPhone}}</div>
                    <div><b><small>{{ $t('telegram.filledCity') }}:</small></b></div>
                    <div>{{userItem.filledCity}}</div>
                    <div><b><small>{{ $t('telegram.filledAddress') }}:</small></b></div>
                    <div>{{userItem.filledAddress}}</div>
                    <div><b><small>{{ $t('telegram.created') }}:</small></b></div>
                    <div>{{moment.utc(userItem.created / 1000, 'X').local().format(DATE_VIEW)}}</div>
                  </td>
                  <td>
                    <div><b><small>{{ $t('telegram.lastActivity') }}:</small></b></div>
                    <div>{{moment.utc(userItem.lastActivity / 1000, 'X').local().format(DATETIME_VIEW)}}</div>
                    <div><b><small>{{ $t('telegram.lastSubmission') }}:</small></b></div>
                    <div>{{moment.utc(userItem.lastSubmission / 1000, 'X').local().format(DATETIME_VIEW)}}</div>
                  </td>
                  <td>
                    <div :key="key" v-for="(value, key) in userItem.tmpData">
                      <b>{{key}}:</b> {{value}}
                    </div>
                  </td>
                </tr>
              </table>
            </v-layout>
          </v-container>
        </div>
        <pagination-listing
          :pagination-data="paginationData"
          @go-prev="changePage('-')"
          @go-next="changePage('+')"
        ></pagination-listing>
      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
import { DATE_VIEW, DATETIMEFULL_VIEW } from '@/constants/dates';
import paginationMixin from '@/mixins/listing/paginationMixin';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import defaultListingMixin from '@/mixins/listing/defaultListingMixin';
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import FilterTelegramBot from '@/components/listings/FilterTelegramBot.vue';
import PaginationListing from '@/components/listings/PaginationListing.vue';
import { PER_PAGE_ORDERS } from '@/constants/listing';
import { deepMerge, strReplaceAll } from '@/utils';
import TelegramBotUserProxy from '@/proxies/TelegramBot/TelegramBotUserProxy';

export default {
  name: 'TelegramBotUsersListing',
  mixins: [
    paginationMixin,
    updatePageContentMixin,
    defaultListingMixin,
  ],
  components: {
    FilterTelegramBot,
    ModalLoading,
    PaginationListing,
  },
  data() {
    return {
      moment,
      DATE_VIEW,
      DATETIME_VIEW: DATETIMEFULL_VIEW,
      currentStockItem: {},
      currentEditableItem: {},
      isShowIncomeDialog: false,
      isShowExpenseDialog: false,
      /* Delete */
      isShowDeleteDialog: false,
      /* Page management */
      pageLoading: false,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE_ORDERS,
        },
        search_contact: '',
        region: null,
      },
    };
  },
  created() {
    this.isTableLoading = true;
  },
  computed: {
    /* accept modal */
    acceptModalText() {
      return strReplaceAll(this.lang(this.$store, 'sap/listings.global.delete.question'), {
        user: this.currentStockItem.name,
      });
    },
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new TelegramBotUserProxy()
        .setParameters(this.searchParams)
        .all()
        .then((response) => {
          this.paginatedObject = response.data.data.items;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    onPaginatedItemDelete(item) {
      this.currentEditableItem = item;
      this.isShowDeleteDialog = true;
    },
    onAcceptDeletion() {
      this.isRequestingNow = true;
      new StockItemProxy().destroy(this.currentStockItem.id)
        .catch((response) => {
          console.error(response);
          alert(`Error: ${response.status}`);
          this.isRequestingNow = false;
        })
        .then(() => {
          this.fetchData();
        });
    },
    onFilter(event) {
      const newSearchParams = Object.assign({}, event);
      this.searchParams = deepMerge(this.searchParams, deepMerge(newSearchParams, {
        page: {
          number: 1,
        },
      }));
    },
    onCloseDialog(item) {
      this.isShowIncomeDialog = false;
      this.isShowExpenseDialog = false;
    },
    onActionDialog(item) {
      this.fetchData();
      this.onCloseDialog();
    },
  },
};
</script>

<style scoped lang="scss">
.tableStockItems {
  width: 100%;
  border-spacing: 0;

  th {
    border: 1px solid #dddddd;
    :nth-child(2),
    :nth-child(3) {
      min-width: 200px;
    }
    :nth-child(4) {
      max-width: 600px;
    }
  }

  td {
    border: 1px solid #dddddd;
    padding: 0 8px;
    :nth-child(2),
    :nth-child(3) {
      min-width: 200px;
    }
    :nth-child(4) {
      max-width: 600px;
    }
  }
}
</style>
